import { render } from "./Landing.vue?vue&type=template&id=52dcbdc2&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.css?vue&type=style&index=0&id=52dcbdc2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dcbdc2"]])

export default __exports__